const commonZh = {
  commonLang: {
    客户名称: '客户名称',
    平台功能更新说明: '平台功能更新说明',
    查看: '查看',
    请选择: '请选择',
    个人信息: '个人信息',
    修改密码: '修改密码',
    退出登录: '退出登录',
    数据大屏: '数据大屏',
    多站总览: '多站总览',
    站点卡片: '站点卡片',
    单站数据: '单站数据',
    电站概览: '电站概览',
    站点系统: '站点系统',
    设备监控: '设备监控',
    故障告警: '故障告警',
    电价管理: '电价管理',
    统计报表: '统计报表',
    电量报表: '电量报表',
    收益报表: '收益报表',
    运维管理: '运维管理',
    工单管理: '工单管理',
    系统管理: '系统管理',
    电站管理: '电站管理',
    公共模版: '公共模版',
    账号管理: '账号管理',
    收起: '收起',

    账号名称: '账号名称',
    账号邮箱: '账号邮箱',
    账号手机: '账号手机',
    账号角色: '账号角色',
    创建时间: '创建时间',
    创建人: '创建人',
    到期时间: '到期时间',

    原密码: '原密码',
    请输入原密码: '请输入原密码',
    新密码: '新密码',
    请输入新密码: '请输入新密码',
    确认新密码: '确认新密码',
    请输入确认密码: '请输入确认密码',
    取消: '取消',
    确定: '确定',
    两次密码不一致请重新输入: '两次密码不一致请重新输入！',
    '密码更改成功，请重新登录': '密码更改成功，请重新登录！',
    提示: '提示',

    该账号目前没有资源权限即将返回登录页: '该账号目前没有资源权限,即将返回登录页...',
    智慧储能云平台: '智慧储能云平台',
    工商业储能云平台: '工商业储能云平台',
    '驰硕-智慧储能云平台': '驰硕-智慧储能云平台',
    '浙江明度-工商业储能云平台': '浙江明度-工商业储能云平台',
    赛唯E宝工商业储能云平台: '赛唯E宝 工商业储能云平台',
    STE智慧储能云: 'STE智慧储能云',
    '云基慧-智慧储能云平台': '云基慧-智慧储能云平台',
    鹏洲储能云平台: '鹏洲储能云平台',
    工商业储能数据云平台: '工商业储能数据云平台',
    智慧储能管控平台: '智慧储能管控平台',
    中汇芯能智慧云平台: '中汇芯能智慧云平台',
    请输入合法数字: '请输入合法数字！',
    手机号码格式不正确: '手机号码格式不正确！',
    邮箱格式不正确: '邮箱格式不正确！',
    密码必须由6至20个字符组成支持字母不区分大小写数字和特殊符号: '密码必须由6-20个字符组成，支持字母（不区分大小写）、数字和特殊符号。'
  }
}
export default commonZh
